import ConfirmYourCredentials, { CREDENTIALS_REQUIRED_MESSAGE } from './ConfirmYourCredentials';

export { CREDENTIALS_REQUIRED_MESSAGE };
export default ConfirmYourCredentials;
